import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CompaniesService } from '@services/companies.service';
import { LoginAttemptModel } from '@data-layer/models/common';
import { WidgetsService } from '@services/widgets.service';
import { enumApplicationMode } from '@enum/enumApplicationMode';
import { ApplicationModeService } from '@services/application-mode.service';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-last-login-attempt',
  templateUrl: './last-login-attempt.component.html',
  styleUrls: ['./last-login-attempt.component.scss'],
})
export class LastLoginAttemptComponent implements OnInit, OnDestroy {
  public loginAttempt: LoginAttemptModel;

  private applicationMode: enumApplicationMode;
  private isDestroy: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(
    private companiesService: CompaniesService,
    private widgetsService: WidgetsService,
    private applicationModeService: ApplicationModeService,
    private cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.companiesService
      .getUserLastLoginAttempt(false)
      .pipe(takeUntil(this.isDestroy))
      .subscribe((loginAttempt: LoginAttemptModel) => {
        this.loginAttempt = loginAttempt;
        this.cdr.markForCheck();
      });
    this.applicationModeService.onActiveApplicationModeChange$.pipe(takeUntil(this.isDestroy)).subscribe(() => {
      this.applicationMode = this.applicationModeService.activeApplicationMode;
    });
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }

  public contactSupport(event: Event) {
    event.preventDefault();
    this.widgetsService.openWidget(['Last login attempt is not from the current user']);
  }

  public get showLoginAttempts(): boolean {
    return this.applicationMode === enumApplicationMode.USER;
  }
}
